




















































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import StatusTag from '@/components/lib/StatusTag.vue'
import OrderServiceItemCard from './OrderServiceItemCard.vue'
import OrderPlanItemCard from './OrderPlanItemCard.vue'
import OrderPromoCodeCard from './OrderPromoCodeCard.vue'
import DropdownCommon from '@/components/lib/DropdownCommon.vue'
import IconCustom from '@/components/lib/IconCustom.vue'
import TimezoneTooltip from "@/components/TimezoneTooltip.vue";
import InputToggleItem from '@/components/lib/InputToggleItem.vue'
import {IOrder, IRequestService, IRequestServiceDisplay} from '@/entities/request/order'
import {IOption, StatusTagType} from '@/components/lib/models'
import {ICustomerExtendData} from "@/entities"
import OrderHistoryList from "@/components/cards/order/OrderHistoryList.vue";

@Component({
  components: {
    OrderHistoryList,
    IconCustom,
    StatusTag,
    OrderServiceItemCard,
    OrderPromoCodeCard,
    OrderPlanItemCard,
    DropdownCommon,
    InputToggleItem,
    TimezoneTooltip
  }
})
export default class OrderCard extends Vue {

  @Prop() readonly data!: IOrder

  private showHistory = false;
  private calledHistory = false;

  private toggleHistory(): void {
    this.showHistory = !this.showHistory;
    this.calledHistory = true;
  }

  get services(): IRequestServiceDisplay[] {
    const sorted: IRequestServiceDisplay[] = this.data.request_service
      ?.sort((a, b) => a.name === b.name ? (a.status > b.status ? 1 : -1) : (a.name > b.name ? 1 : -1)) || [];
    sorted?.forEach((s, index) => {
      const next = sorted[index + 1];
      if (next) {
        s.classes = (next.name === s.name && next.status === s.status) ? 'same' : '';
      }
    });
    return sorted;
  }

  get canCancel(): boolean {
    return !(this.cancellationOrder || ['done'].includes(this.data.status));
  }

  get canViewOrder(): boolean {
    return !(this.cancellationOrder || ['new'].includes(this.data.status));
  }

  get cancellationOrder(): boolean {
    return ['cancelled', 'cancellation'].includes(this.data.status);
  }

  get paidOrder(): boolean {
    return ['done', 'paid'].includes(this.data.status);
  }

  private cancel(): void {
    this.$storage.actions.cancelOrder({
      key: this.data.token
    })
    .then(res => {
      this.$emit('update:data', res);
    });
  }

  private appendService(service: IRequestService): void {
    this.data.request_service = this.data.request_service || [];
    const services = this.data.request_service;
    services.push(service);
  }

  get historyToggleTitle(): string {
    return this.$t('order.history.' + (this.showHistory ? 'off' : 'on')) as string;
  }

  get historyToggleOption(): IOption<string> {
    return {
      name: this.$t('ok') as string,
      value: this.showHistory ? 'show' : ''
    }
  }

  get dateCreation(): string {
    let date = this.data?.date_creation;
    return date ? this.$storage.getters.getLocaleDate(date) : '';
  }

  get haveMenu(): boolean {
    return this.canCancel || !!this.data.receipt;
  }

  get customer(): ICustomerExtendData {
    return this.data.customer
  }

  get name(): string {
    return this.$storage.getters.getPlatformInfo().name;
  }

  private mapStatus(status?: string): StatusTagType {
    switch (status) {
      case "confirmed":
      case "paid":
        return 'progress'
      case "done":
        return 'success'
      case "cancellation":
      case "cancelled":
        return 'danger'
      case "processing":
      case "waiting":
        return 'warning'
      default: return 'none'
    }
  }

  get mappedStatus(): StatusTagType {
    return this.mapStatus(this.data.status);
  }

  private toPay(): void {
    this.$storage.actions.setOrder(this.data);
    this.$router.push({ name: 'Checkout' });
  }

}
